let openInstallInstance = null;

function getUrlParams(extraParams = {}) {
  const data = OpenInstall.parseUrlParams();
  return Object.assign(data, extraParams);
}

export function initKszbOpenInstall(appKey, extraParams = {}) {
  openInstallInstance = new OpenInstall(
    {
      appKey,
      onready: function () {
        this.schemeWakeup();
        return false;
      },
    },
    getUrlParams(extraParams)
  );
}

export function kszbOpenInstallDownload() {
  if (openInstallInstance) {
    openInstallInstance.wakeupOrInstall();
  }
}
